import React from 'react';
import Link from 'next/link';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import { IndexCustomHead } from '@common/customHead';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from '../components/error/error.module.scss';

const cx = classnames.bind(styles);

const Custom404Page = () => {
  const errorType = Math.floor(Math.random() * 4) + 1;

  return (
    <Layout>
      <IndexCustomHead />
      <Header />
      <Content>
        <div className={cx('errorArea', `error404_${errorType}`)}>
          <strong className={cx('title')}>요청하신 페이지를 찾을 수 없어요</strong>
          <p className={cx('desc')}>
            페이지가 존재하지 않거나 사용할 수 없는 페이지입니다.
            <br />
            입력하신 주소가 정확한지 다시 한번 확인해 주세요.
          </p>
          <Link href={RouteUrl.INDEX} legacyBehavior>
            <a className={cx('link')} role="button">
              홈으로 가기
            </a>
          </Link>
        </div>
      </Content>
    </Layout>
  );
};

export default Custom404Page;
